import React from 'react';
import { Button, Grid, SwitchDialogWindows, TextInput } from 'ui-toolkit/components';
import { IStandardDocumentVersionData } from 'types/order/documents/shared/interfaces';
import { IFetchDataState } from 'store/IFetchDataState';
import { ICreateDocumentAccess } from 'types/documents/ICreateDocumentAccess';
import { IDocumentAccessData } from 'types/documents/IDocumentAccess';
import { ShareableLinkForm } from './ShareableLinkForm';
import { copyTextToClipboard } from '../../../../utilities/shared/copyTextToClipboard';

export interface IShareableLinkModalProps {
  onClose: () => void;
  onGenerateLink: (createDocumentAccess: ICreateDocumentAccess) => void;
  postGenerateLink: IFetchDataState<ICreateDocumentAccess, IDocumentAccessData>;
  standardDocument: IStandardDocumentVersionData | null;
}

export const ShareableLinkModal: React.FC<IShareableLinkModalProps> = ({
  onClose,
  onGenerateLink,
  postGenerateLink,
  standardDocument,
}) => {
  const { fetchStatus, fetchError, data } = postGenerateLink;
  return (
    <SwitchDialogWindows
      isCompleted={fetchStatus.fetched}
      isLoading={fetchStatus.fetching}
      isError={!!fetchError}
      onCloseClick={onClose}
      successMessage={<SuccessMessage link={data.downloadUrl} />}
      successTitle={`${standardDocument?.fileName}`}
      errorMessage={fetchError?.message}
      loadingTitle={'Generating the link for sharing.'}
      modalUiType={'fit'}
    >
      <ShareableLinkForm onClose={onClose} standardDocument={standardDocument} onSubmit={onGenerateLink} />
    </SwitchDialogWindows>
  );
};

const SuccessMessage: React.FC<{ link: string }> = ({ link }) => (
  <Grid templateColumns={'1fr min-content'} alignItems={'end'}>
    <TextInput value={link} readOnly label={'Shareable Link'} />
    <Button intent={'primary'} onClick={() => copyTextToClipboard(link)}>
      Copy
    </Button>
  </Grid>
);
